import apiClient from '../apiClient';

export const getSummaryStats = async () => {
  try {
    const response = await apiClient.get('/admin/analytics/summary');
    return {
      totalSales: response.data.total_sales,
      totalOrders: response.data.total_orders,
      averageBasketValue: response.data.average_order,
      pendingPayments: response.data.pending_orders,
      lowStockProducts: response.data.low_stock_products,
      todaySales: response.data.today_sales,
    };
  } catch (error) {
    console.error('Error calculating summary stats:', error);
    throw error;
  }
};

export const getSalesChartData = async (period = 'daily', days = 30) => {
  try {
    const response = await apiClient.get('/admin/analytics/sales', {
      params: { period, days },
    });
    return response.data.map((item) => ({
      date: item.date,
      sales: item.total,
      count: item.count ?? 0,
    }));
  } catch (error) {
    console.error('Error calculating sales chart data:', error);
    throw error;
  }
};

export const getTopProducts = async (limitCount = 10) => {
  try {
    const response = await apiClient.get('/admin/analytics/top-products', {
      params: { limit: limitCount },
    });
    return response.data.map((item) => ({
      productId: item.product_id,
      quantity: item.quantity || 0,
      revenue: item.revenue,
      name: item.name,
      image: item.image || null,
    }));
  } catch (error) {
    console.error('Error fetching top products:', error);
    throw error;
  }
};

export const getCategoryStats = async () => {
  try {
    const response = await apiClient.get('/admin/analytics/categories');
    return response.data.map((item) => ({
      name: item.name,
      count: item.product_count ?? item.count ?? 0,
    }));
  } catch (error) {
    console.error('Error fetching category stats:', error);
    throw error;
  }
};

export const getRecentOrders = async (limitCount = 5) => {
  try {
    const response = await apiClient.get('/admin/analytics/recent-orders', {
      params: { limit: limitCount },
    });
    return response.data.map((order) => ({
      id: order.order_id,
      orderNumber: order.order_number,
      customerInfo: { fullName: order.customer_name || '' },
      total: order.total_amount,
      status: order.status,
      createdAt: order.created_at,
    }));
  } catch (error) {
    console.error('Error fetching recent orders:', error);
    throw error;
  }
};

export const getLowStockProducts = async (threshold = 10) => {
  try {
    const response = await apiClient.get('/admin/analytics/low-stock', {
      params: { threshold },
    });
    return response.data.map((product) => ({
      id: product.product_id,
      name: product.name,
      stock: product.stock,
      image: product.image || null,
    }));
  } catch (error) {
    console.error('Error fetching low stock products:', error);
    throw error;
  }
};
